import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;


export class roi_tool_template extends vnTemplate{

    protected brandsFilter : multipleSelector_template;
    protected postInitiativesFilter : multipleSelector_template;
    protected postIntentsFilter : multipleSelector_template;
    protected postContentTypesFilter : multipleSelector_template;
    protected networkCategoriesFilter : multipleSelector_template;
    protected primaryCategoriesFilter: filterMultipleAutoComplete_template;
    protected srEditorsFilter: filterMultipleAutoComplete_template;
    protected jrEditorsFilter: filterMultipleAutoComplete_template;
    protected datesFilter: filterDate_template;
    protected dimensionGrouping : multipleSelector_template;
    protected costsFilter : multipleSelector_template;
    protected exportRoiDataCsv: exportDataCsv;
    protected exportRoiReconciliationDataCsv: exportDataCsv;
    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;
    public toolTipFailure: infoButton_template;
    public toolTipSuccess: infoButton_template;


    static dimensionGroupingItems : Array<{id : string, name : string, backendName: string, displayName:string }> = [
        { "id": "dateData",  "name": "Day", "backendName": "Day", "displayName" : "dateData"},
        { "id": "monthYear",  "name": "Month", "backendName": "monthYear", "displayName" : "dateData"},
        { "id": "idBrand",  "name": "Brand", "backendName": "brand", "displayName" : "brandShortName"},
        { "id": "idSegment",  "name": "Segment", "backendName": "segmentName", "displayName" : "segmentName"},
        { "id": "idInitiative",  "name": "Initiative", "backendName": "initiative", "displayName" : "initiativeName"},
        { "id": "idPrimaryCategory",  "name": "Primary Category", "backendName": "primary_category", "displayName" : "primaryCategoryName"},
        { "id": "idIntent",  "name": "Intent", "backendName": "intent", "displayName" : "intentName"},
        { "id": "idContentType",  "name": "Content Type", "backendName": "content_type", "displayName" : "contentTypeName"},
        { "id": "idNetworkCategory",  "name": "Network Category", "backendName": "network_category", "displayName" : "networkCategoryName"},
        { "id": "idEditor",  "name": "Sr Editor", "backendName": "sr_editor", "displayName" : "editorName"},
        { "id": "idJrEditor", "name": "Jr Editor", "backendName": "jr_editor", "displayName" : "jrEditorName"}
    ];

    static staticHeadersList : Array<{name : string}> = [
        {"name": "nbrPublished"},
        {"name": "ppp"},
        {"name": "ppv"},
        {"name": "writerCost"},
        {"name": "editorCost"},
        {"name": "totalCost"},
        {"name": "costPerArticle"},
        {"name": "revenue"},
        {"name": "adjRevenue"},
        {"name": "roi"},
        {"name": "adjRoi"},
        {"name": "sessions"},
        {"name": "sessionsPerArticle"},
        {"name": "activeSessionsPerArticle"},
        {"name": "pageviews"},
        {"name": "pageviewsPerSession"}
    ];

    readonly publishStatus = [
        { "id": "all", "name": "all"},
        { "id": "publish", "name": "publish"},
        { "id": "republish", "name": "republish"}
    ];


    readonly costs = [
        { "id": "employee", "name": "Employee"},
        { "id": "freelancer", "name": "Freelancer"},
    ];

    protected getTemplateHtml(): string {
        return `
            <div class="sub-header w-justify"> </div>
            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-roi">ROI Tool</h2>
                </div>
            </div>
            <div style="position: absolute;width: 100%;height: 100%;margin: 0 auto">
                <p style="text-align: center;position: relative;font-family:  'Lato', sans-serif; font-size: 1.8rem; font-weight: 1000; color: #085070; display: inline-block;">This report no longer exists. Please contact IT with any questions you may have.</p>
            </div>
        `;
    }
    /*protected getTemplateHtml(): string {

        return  `
            <div class="sub-header w-justify">

                ` + this.presetFilter.getHtmlBuild() + `

                <div class="w-left">
                    
                    <div class="multi-temp">` + this.dimensionGrouping.getHtmlBuild() + `</div>
                    ` + this.brandsFilter.getHtmlBuild() + ` 
                    ` + this.postInitiativesFilter.getHtmlBuild() + ` 
                    ` + this.postIntentsFilter.getHtmlBuild() + ` 
                    ` + this.postContentTypesFilter.getHtmlBuild() + ` 
                    ` + this.networkCategoriesFilter.getHtmlBuild() + `
                    ` + this.primaryCategoriesFilter.getHtmlBuild() + `
                    ` + this.srEditorsFilter.getHtmlBuild() + `
                    ` + this.jrEditorsFilter.getHtmlBuild() + ` 
                    ` + this.datesFilter.getHtmlBuild() + `
                    

                    
                    
                    <div class="dropdown select-single">
                        <label class="form-label" for="">Publishing type</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: publishStatusSelected"></button>
                        
                        <div class="dropdown-list"> 
                            <div class="w-form">   
                                <div class="form-group" data-bind="foreach: publishStatus">
                                    <input type="radio" data-bind="checked : $parent.publishStatusSelected, value: id,  attr: { 'id': 'pub_status_' + id, 'name' : 'pub_status_' + id }, event:{ change: $parent.onPublishStatusChange}">
                                    <label class="form-label" data-bind="attr: {for : 'pub_status_' + id }, text: name"></label>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                     
                    <!-- ko if: permissions()['roi tool page cost breakdown'].read -->
                        ${ this.costsFilter.getHtmlBuild() }
                    <!-- /ko -->
                    
                </div>
             
                 
            </div>
            
            ` + this.validationsList.getHtmlBuild()  + `
                        
             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-dimensions"></div>
                   <div id="selected-brands"></div>
                   <div id="selected-initiatives"></div>
                   <div id="selected-intents"></div>
                   <div id="selected-content_types"></div>
                   <div id="selected-network_categories"></div>
                   <div id="selected-sr_editors"></div>
                   <div id="selected-jr_editors"></div>
                    <!-- ko if: permissions()['roi tool page cost breakdown'].read -->
                        <div id="selected-costs"></div>
                    <!-- /ko -->
                    <div id="selected-primary_categories"></div>
                    <div id="selected-senior_editors"></div>
                    <div id="selected-junior_editors"></div>
                </div>   
            </div>
            
            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-roi">ROI Tool</h2>
                    
                    <div class="w-calculating" data-bind="visible:inProgress().length">
                        <div class="w-title">
                            <h3 class="icon i-settings">calculating...</h3>
                        </div>
                        <div class="calculating" data-bind="foreach: inProgress">
                            <div><strong data-bind="text:brand"></strong></span></div>
                        </div>
                        <div class="alert icon done">
                            <p>Updated data is being inserted.<br />Please refresh.</p>
                        </div>
                    </div>
                    
                </div>
                <div class="w-right">
                    <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportData}, css: { 'is-hidden': exportButtonHidden }">Export</button>
                    <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportReconciliationData}, css: { 'is-hidden': permissions()['roi tool page reconciliation data'].read == false || exportReconciliationButtonHidden, 'is-loading': roiReconciliationDataButtonClickable() == false }">Reconciliation Export</button>
                </div>
            </div>
                           
            <div class="w-list-results" id="list-results" style="padding-bottom: 200px">

                <table class="list-results list-sections thin">
                    <thead>
                    <tr>   
                        <!-- ko foreach: dynamicHeadersList -->
                            
                            <th><span class="icon list-sort-none" data-bind="text: name, event: { click: $parent.onClickReorder.bind($data, backendName) }, css: { 'list-sort-desc': $parent.orderByAndDirection()== backendName + '_DESC', 'list-sort-asc': $parent.orderByAndDirection()== backendName + '_ASC' }" class="icon i-dropdown-simple"></span></th>
                        <!-- /ko -->     
                            
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleCount') }, css: { 'list-sort-desc': orderByAndDirection()=='articleCount_DESC', 'list-sort-asc': orderByAndDirection()=='articleCount_ASC' }" class="icon i-dropdown-simple">Art. Pub.</span></th>
                        <th data-bind="visible: costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'pppPerArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='pppPerArticle_DESC', 'list-sort-asc': orderByAndDirection()=='pppPerArticle_ASC' }" class="icon i-dropdown-simple">PPP/Art.</span></th>
                        <th data-bind="visible: costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'writerCost') }, css: { 'list-sort-desc': orderByAndDirection()=='writerCost_DESC', 'list-sort-asc': orderByAndDirection()=='writerCost_ASC' }" class="icon i-dropdown-simple">Wr. Base</span></th>
                        <th data-bind="visible: costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'editorCost') }, css: { 'list-sort-desc': orderByAndDirection()=='editorCost_DESC', 'list-sort-asc': orderByAndDirection()=='editorCost_ASC' }" class="icon i-dropdown-simple">Ed. Base</span></th>
                        <th data-bind="visible: costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'contentCostPerArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='contentCostPerArticle_DESC', 'list-sort-asc': orderByAndDirection()=='contentCostPerArticle_ASC' }" class="icon i-dropdown-simple">Content Cost /Art.</span></th>
                        <th data-bind="visible: costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'indirectCost') }, css: { 'list-sort-desc': orderByAndDirection()=='indirectCost_DESC', 'list-sort-asc': orderByAndDirection()=='indirectCost_ASC' }" class="icon i-dropdown-simple">Indirect Cost</span></th>
                        <th data-bind="visible: costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'writerBonus') }, css: { 'list-sort-desc': orderByAndDirection()=='writerBonus_DESC', 'list-sort-asc': orderByAndDirection()=='writerBonus_ASC' }" class="icon i-dropdown-simple">Wr. Bonus</span></th>
                        <th data-bind="visible: costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'editorBonus') }, css: { 'list-sort-desc': orderByAndDirection()=='editorBonus_DESC', 'list-sort-asc': orderByAndDirection()=='editorBonus_ASC' }" class="icon i-dropdown-simple">Ed. Bonus</span></th>
                        <th data-bind="visible: costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'managerBonus') }, css: { 'list-sort-desc': orderByAndDirection()=='managerBonus_DESC', 'list-sort-asc': orderByAndDirection()=='managerBonus_ASC' }" class="icon i-dropdown-simple">Manager Bonus</span></th>
                        <th data-bind="visible: costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'indirectBonus') }, css: { 'list-sort-desc': orderByAndDirection()=='indirectBonus_DESC', 'list-sort-asc': orderByAndDirection()=='indirectBonus_ASC' }" class="icon i-dropdown-simple">Indirect Bonus</span></th>
                        <th data-bind="visible: costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'vsCost') }, css: { 'list-sort-desc': orderByAndDirection()=='vsCost_DESC', 'list-sort-asc': orderByAndDirection()=='vsCost_ASC' }" class="icon i-dropdown-simple">Video</span></th>
                        <th data-bind="visible: costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalCost') }, css: { 'list-sort-desc': orderByAndDirection()=='totalCost_DESC', 'list-sort-asc': orderByAndDirection()=='totalCost_ASC' }" class="icon i-dropdown-simple">ΣCost</span></th>
                        <th data-bind="visible: costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'costPerArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='costPerArticle_DESC', 'list-sort-asc': orderByAndDirection()=='costPerArticle_ASC' }" class="icon i-dropdown-simple">Total Cost /Art.</span></th>
                        <th data-bind="visible: financialPermissions() && costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'adjRevenue') }, css: { 'list-sort-desc': orderByAndDirection()=='adjRevenue_DESC', 'list-sort-asc': orderByAndDirection()=='adjRevenue_ASC' }" class="icon i-dropdown-simple">Adj. Rev</span></th>
                        <th data-bind="visible: financialPermissions() && costPermissions()"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'adjRoi') }, css: { 'list-sort-desc': orderByAndDirection()=='adjRoi_DESC', 'list-sort-asc': orderByAndDirection()=='adjRoi_ASC' }" class="icon i-dropdown-simple">Adj. ROI</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'sessions') }, css: { 'list-sort-desc': orderByAndDirection()=='sessions_DESC', 'list-sort-asc': orderByAndDirection()=='sessions_ASC' }" class="icon i-dropdown-simple">Sess</span></th>
                        <th><span style="padding: 0 2rem 0 0;" class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'sessionsPerArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='sessionsPerArticle_DESC', 'list-sort-asc': orderByAndDirection()=='sessionsPerArticle_ASC' }" class="icon i-dropdown-simple">Sess /Art.</span></th>
                        <th><span style="padding: 0 2rem 0 0;" class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'activeSessionsPerArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='activeSessionsPerArticle_DESC', 'list-sort-asc': orderByAndDirection()=='activeSessionsPerArticle_ASC' }" class="icon i-dropdown-simple">Active Sess /Art.</span></th>
                        <th>
                            <div style="display: flex;align-items: center; padding: 0;position: relative;" >
                                <span data-bind="event: { click: onClickReorder.bind($data, 'successRate') }, css: { 'list-sort-desc': orderByAndDirection()=='successRate_DESC', 'list-sort-asc': orderByAndDirection()=='successRate_ASC' }" class="faux-span icon list-sort-none i-dropdown-simple">
                                    Success Rate
                                </span>

                                <div style="position: absolute;right: -5px;" class="w-tooltips-adv roi-tool auto-height short">
                                    ` + this.toolTipSuccess.getHtmlBuild() + `
                                </div>
                            </div>
                        </th>
                        <th>
                            <div style="display: flex;align-items: center; padding: 0;position: relative;" >
                                <span data-bind="event: { click: onClickReorder.bind($data, 'failureRate') }, css: { 'list-sort-desc': orderByAndDirection()=='failureRate_DESC', 'list-sort-asc': orderByAndDirection()=='failureRate_ASC' }" class="faux-span icon list-sort-none i-dropdown-simple">
                                    Failure Rate
                                </span>

                                <div style="position: absolute;right: -5px;" class="w-tooltips-adv roi-tool auto-height short">
                                  ` + this.toolTipFailure.getHtmlBuild() + `
                                </div>
                            </div>
                        </th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'pageviews') }, css: { 'list-sort-desc': orderByAndDirection()=='pageviews_DESC', 'list-sort-asc': orderByAndDirection()=='pageviews_ASC' }" class="icon i-dropdown-simple">PG</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'PGSPerSession') }, css: { 'list-sort-desc': orderByAndDirection()=='PGSPerSession_DESC', 'list-sort-asc': orderByAndDirection()=='PGSPerSession_ASC' }" class="icon i-dropdown-simple">PG/S</span></th>
                   </tr> 
                        
                       
                    </thead>
                    <tbody data-bind="foreach: roiData">
                        <tr>
                            <!-- ko foreach: $parent.dynamicHeadersList -->
                            
                            <!-- ko if: ($parentContext.$index() === 0 || $parents[1].roiData()[$parentContext.$index() - 1][backendName] != $parent[backendName] || $index() === $parents[1].dynamicHeadersList().length - 1) -->
                                <!-- ko if: $parentContext.$index() === $parents[1].roiData().length - 1 || $index() === $parents[1].dynamicHeadersList().length - 1 || $parents[1].roiData()[$parentContext.$index() + 1][backendName] != $parent[backendName]-->
                                    <td class="group single"><span class="no-wrap" data-bind="text: $parent[backendName]"></span></td>
                                <!-- /ko -->
                                <!-- ko ifnot: $parentContext.$index() === $parents[1].roiData().length - 1 || $index() === $parents[1].dynamicHeadersList().length - 1 || $parents[1].roiData()[$parentContext.$index() +1][backendName] != $parent[backendName]-->
                                    <td class="group first"><span data-bind="text: $parent[backendName]"></span></td>
                                <!-- /ko -->
                            <!-- /ko --> 
                            <!-- ko ifnot: ($parentContext.$index() === 0 || $parents[1].roiData()[$parentContext.$index() - 1][backendName] != $parent[backendName] || $index() === $parents[1].dynamicHeadersList().length - 1) -->
                                <td class="group"><span></span></td>
                            <!-- /ko --> 
                            
                            <!-- /ko --> 
                            
                            <td class=""><span class="no-wrap" data-bind="text: articleCount"></span></td>
                            <td data-bind="visible: $parent.costPermissions()" class=""><span data-bind="text: Number(pppPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td data-bind="visible: $parent.costPermissions()" class=""><span data-bind="text: Number(writerCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td data-bind="visible: $parent.costPermissions()" class=""><span data-bind="text: Number(editorCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td data-bind="visible: $parent.costPermissions()" class=""><span data-bind="text: Number(contentCostPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            
                            <td data-bind="visible: $parent.costPermissions()" class=""><span data-bind="text: Number(indirectCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>                            
                            <td data-bind="visible: $parent.costPermissions()" class=""><span data-bind="text: Number(writerBonus).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td data-bind="visible: $parent.costPermissions()" class=""><span data-bind="text: Number(editorBonus).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td data-bind="visible: $parent.costPermissions()" class=""><span data-bind="text: Number(managerBonus).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td data-bind="visible: $parent.costPermissions()" class=""><span data-bind="text: Number(indirectBonus).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td data-bind="visible: $parent.costPermissions()" class=""><span data-bind="text: Number(vsCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td data-bind="visible: $parent.costPermissions()" class=""><span data-bind="text: Number(totalCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td data-bind="visible: $parent.costPermissions()" class=""><span data-bind="text: Number(costPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td data-bind="visible: $parent.financialPermissions() && $parent.costPermissions()"><span data-bind="text: Number(adjRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td data-bind="visible: $parent.financialPermissions() && $parent.costPermissions()" class="no-wrap"><span data-bind="text: Number(adjRoi).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class=""><span data-bind="text: Number(sessions).toLocaleString('en-EG')"></span></td>
                            <td class=""><span data-bind="text: Number(sessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class=""><span data-bind="text: ($parent.publishStatusSelected() == 'publish' || $parent.publishStatusSelected() == 'all') ? Number(activeSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"></span></td>
                            <td class="align-left" style="padding-left: 0;padding-right: 0;" data-bind="attr: {title: 'Success rate based on a blended sessions target of ' + Number(blendedTargetSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' sessions per published article.'}">

                                <!-- ko if: ($parent.publishStatusSelected() == 'publish' || $parent.publishStatusSelected() == 'all') -->
                                <div class="flex">
                                    <span style="margin-left: 2rem;" data-bind="text: (successRate != null && blendedTargetSessions != 0) ? Number(successRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%' : ''"></span>
                                </div>
                                <!-- /ko -->
                            </td>
                            <td class="align-left" style="padding-left: 0;padding-right: 0;" data-bind="attr: {title: 'Failure rate based on ' + (Number(isPassedCount) + Number(isFailureCount)) + ' articles out of ' + (Number(isPassedCount) + Number(isFailureCount) + Number(isPendingCount)) + '.'}, css: { 'is-empty': Number(isPendingCount) == 0 && Number(isPassedCount) == 0 && Number(isFailureCount) == 0, 'is-pending': Number(isPendingCount) > 0 && Number(isPassedCount) == 0 && Number(isFailureCount) == 0, 'is-running': Number(isPendingCount) > 0 && (Number(isPassedCount) > 0 || Number(isFailureCount) > 0) }">
                            
                                <!-- ko if: ($parent.publishStatusSelected() == 'publish' || $parent.publishStatusSelected() == 'all') -->
                                <div class="flex">
                                    <span style="margin-left: 2rem;" data-bind="text: (failureRate != null) ? Number(failureRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%' : ''"></span>
                                </div>
                                <!-- /ko -->
                            </td>
                            <td class="" style="padding: 0.5rem 2rem 0.5rem 0;"><span data-bind="text: Number(pageviews).toLocaleString('en-EG')"></span></td>
                            <td class=""><span data-bind="text: Number(PGSPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                        </tr>
                            
                    </tbody>
                </table>
            </div>
            `;
    }*/

    protected initPartial():void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('roi_tool');

        this.dimensionGrouping = new multipleSelector_template("dimensionGrouping", this.getTemplateViewModel(), this.caller);
        this.dimensionGrouping.setLabel("Dimensions");
        this.dimensionGrouping.setFilterContainerClass('margin-neg');
        this.dimensionGrouping.setTagContainerId('selected-dimensions');
        this.dimensionGrouping.setTagContainerCaption('Selected dimensions:');
        this.dimensionGrouping.setItems(roi_tool_template.dimensionGroupingItems);
        this.dimensionGrouping.setSelectAllEnabled(false);
        this.dimensionGrouping.setDisplaySelectionOrder(true);

        // In order for preset filters to work with this report, we must make sure to not overwrite the dimensionGrouping if it's already set in the URL
        if (window.location.href.search(/dimensionGrouping/gi) == -1){

            this.dimensionGrouping.getTemplateViewModel().selectedItems(["dateData"]);
            this.dimensionGrouping.setSelectedItemsOrderBySelection([{"id":"dateData"}]);
            this.getTemplateViewModel().groupingDimensionsSelected.push({ "id": "dateData",  "name": "Day", "backendName": "Day", "displayName" : "dateData"});
        }

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('Selected brands:');
        this.brandsFilter.setLabel("brands");
        this.brandsFilter.setLogoEnabled(true);


        this.postInitiativesFilter = new multipleSelector_template("postInitiativesFilter", this.getTemplateViewModel(), this.caller);
        this.postInitiativesFilter.setLabel("Mappings");
        this.postInitiativesFilter.setFilterContainerClass('margin-neg');
        this.postInitiativesFilter.setTagContainerId('selected-initiatives');
        this.postInitiativesFilter.setTagContainerCaption('Selected mappings:');

        this.postIntentsFilter = new multipleSelector_template("postIntentsFilter", this.getTemplateViewModel(), this.caller);
        this.postIntentsFilter.setLabel("Intents");
        this.postIntentsFilter.setFilterContainerClass('margin-neg');
        this.postIntentsFilter.setTagContainerId('selected-intents');
        this.postIntentsFilter.setTagContainerCaption('Selected intents:');

        this.postContentTypesFilter = new multipleSelector_template("postContentTypesFilter", this.getTemplateViewModel(), this.caller);
        this.postContentTypesFilter.setLabel("content types");
        this.postContentTypesFilter.setTagContainerId('selected-content_types');
        this.postContentTypesFilter.setTagContainerCaption('Selected content types:');

        this.networkCategoriesFilter = new multipleSelector_template("networkCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoriesFilter.setLabel("network categories");
        this.networkCategoriesFilter.setTagContainerId('selected-network_categories');
        this.networkCategoriesFilter.setTagContainerCaption('Selected network categories:');

        this.costsFilter = new multipleSelector_template("costsFilter", this.getTemplateViewModel(), this.caller);
        this.costsFilter.setLabel("Employment Status");
        this.costsFilter.setTagContainerId('selected-costs');
        this.costsFilter.setTagContainerCaption('Selected employment statuses:');

        this.primaryCategoriesFilter = new filterMultipleAutoComplete_template("primaryCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.primaryCategoriesFilter.setIsVisible(1);
        this.primaryCategoriesFilter.setPlaceHolderText("Primary Category");
        this.primaryCategoriesFilter.setIcon("i-tag-a");
        this.primaryCategoriesFilter.setTagContainerId('selected-primary_categories');
        this.primaryCategoriesFilter.setTagContainerCaption('Selected Primary Categories:');
        this.primaryCategoriesFilter.setMinInputSuggestionLength(2);

        this.srEditorsFilter = new filterMultipleAutoComplete_template("srEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.srEditorsFilter.setIsVisible(1);
        this.srEditorsFilter.setPlaceHolderText("Senior Editor");
        this.srEditorsFilter.setTagContainerId('selected-senior_editors');
        this.srEditorsFilter.setTagContainerCaption('Selected Senior Editors:');
        this.srEditorsFilter.setMinInputSuggestionLength(2);

        this.jrEditorsFilter = new filterMultipleAutoComplete_template("jrEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.jrEditorsFilter.setIsVisible(1);
        this.jrEditorsFilter.setPlaceHolderText("Junior Editor");
        this.jrEditorsFilter.setTagContainerId('selected-junior_editors');
        this.jrEditorsFilter.setTagContainerCaption('Selected Junior Editors:');
        this.jrEditorsFilter.setMinInputSuggestionLength(2);

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);

        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if(date.getTime() === firstOfMonth.getTime()){
            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
            date.setDate(date.getDate() - 1);
        }else{
            date.setDate(date.getDate() - 1);
        }

        this.datesFilter.setDateRange(firstOfMonth, date);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        this.exportRoiDataCsv = new exportDataCsv();

        this.exportRoiReconciliationDataCsv = new exportDataCsv();

        let toolTipFailureContent = `
            <p>Failure Rate is based on the count of articles which fall below the established session threshold within the initial 30 days of publication.</p>
            <p>An article that is less than 30 days old will be considered pending.</p>
            <p>Sessions are attributed to articles if that article was the ‘Landing Page’ (i.e. first visited page) of that session.</p>
        `;
        this.toolTipFailure = new infoButton_template('toolTipFailure', this.getTemplateViewModel(), this.caller)
        this.toolTipFailure.setTitle('Failure Rate');
        this.toolTipFailure.setContent(toolTipFailureContent);

        let toolTipSuccessContent = `
            <p>Success Rate is calculated by dividing the active sessions by the blended target sessions.</p>
            <p>Active sessions are sessions which happened for an article which is less than 30-days old.</p>
            <p>Blended Target Sessions is the sum of the session targets for that month (including the content type exceptions, if this exists) for each published article.</p>
        `;
        this.toolTipSuccess = new infoButton_template('toolTipSuccessContent', this.getTemplateViewModel(), this.caller)
        this.toolTipSuccess.setTitle('Success Rate');
        this.toolTipSuccess.setContent(toolTipSuccessContent);
    }

    protected getTemplateName(): string{

        return "roi_tool_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }


    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            orderBy                                     : ko.observable("Day")
            ,orderByDirection                           : ko.observable("ASC")
            ,orderByAndDirection                        : ko.observable("Day_ASC")
            ,roiData                                    : ko.observableArray([])
            ,roiReconciliationData                      : ko.observableArray([])
            ,roiReconciliationDataButtonClickable       : ko.observable(1)
            ,inProgress                                 : ko.observableArray()
            ,groupingDimensionsSelected                 : ko.observableArray([])
            ,dynamicHeadersList                         : ko.observableArray([])
            ,exportButtonHidden                         : ko.observable(1)
            ,exportReconciliationButtonHidden           : ko.observable(0)
            ,publishStatus                              : ko.observableArray([])
            ,publishStatusSelected                      : ko.observable("all")
            ,financialPermissions                       : ko.observable(false)
            ,costPermissions                            : ko.observable(false)
            ,permissions                                : ko.observableArray(this.initPermissions(['roi tool page cost breakdown', 'roi tool page reconciliation data']))
            ,onClickReorder                             : function(value, data, event){ huit_neuf_this.onClickReorder(value, data, event); }
            ,exportData                                 : function(){ huit_neuf_this.exportData(huit_neuf_this); }
            ,exportReconciliationData                   : function(){ huit_neuf_this.exportReconciliationData(huit_neuf_this); }
            ,onPublishStatusChange                      : function(data){ huit_neuf_this.onPublishStatusChange(); }
        };
    }

    public getViewModelForRequest(){

        return {
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            brands: this.getTemplateViewModel().brandsFilter.selectedItems(),
            postInitiatives: this.getTemplateViewModel().postInitiativesFilter.selectedItems(),
            postIntents: this.getTemplateViewModel().postIntentsFilter.selectedItems(),
            postContentTypes: this.getTemplateViewModel().postContentTypesFilter.selectedItems(),
            networkCategories: this.getTemplateViewModel().networkCategoriesFilter.selectedItems(),
            idPrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemIds(),
            namePrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemNames(),
            srEditors: this.getTemplateViewModel().srEditorsFilter.selectedItemIds(),
            srEditorName: this.getTemplateViewModel().srEditorsFilter.selectedItemNames(),
            jrEditors: this.getTemplateViewModel().jrEditorsFilter.selectedItemIds(),
            jrEditorName: this.getTemplateViewModel().jrEditorsFilter.selectedItemNames(),
            dimensionGroupings: this.getTemplateViewModel().groupingDimensionsSelected(),
            dateFilterType: this.getTemplateViewModel().datesFilter.selectedFilter(),
            startDate: this.getTemplateViewModel().datesFilter.startDate(),
            endDate: this.getTemplateViewModel().datesFilter.endDate(),
            startDateRange: this.getTemplateViewModel().datesFilter.fromRange(),
            endDateRange: this.getTemplateViewModel().datesFilter.toRange(),
            publishStatus: this.getTemplateViewModel().publishStatusSelected(),
            costs: this.getTemplateViewModel().costsFilter.selectedItems(),
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        return super.build(classesToAdd);
    }

    //build the date Picker calendar
    public buildDatePickerCalendar(){
        this.datesFilter.buildCalendar();
    }

    public initiateDimensionSelectTag(){
        this.dimensionGrouping.setTags(["dateData"], roi_tool_template.dimensionGroupingItems);
    }

    public setFinancialPermissions(financialPermissions){

        this.getTemplateViewModel().financialPermissions(financialPermissions);
    }

    public setCostPermissions(costPermissions){

        this.getTemplateViewModel().costPermissions(costPermissions);
    }

    public setBrandFilterItems(departments){
        let groups = [];
        for ( let department of departments){

            let brands = [];
            for( let brand of department.brands){

                if(brand.segments.length > 0){

                    for(let segment of brand.segments){

                        brands.push(segment);
                    }
                }
                else{

                    brands.push(brand);
                }
            }

            let group = {"name" : department.name, "logo" : department.logo, "items" : brands};
            groups.push(group);
        }
        this.brandsFilter.setMultiSectionItems(groups);
        this.brandsFilter.setLabel('Brands');
    }

    public setPostInitiativesFilterItems(items){
        for (let item of items){
            item['name'] = item['initiative'];
        }
        items.unshift({'id': 0, 'name' : 'no mappings'});
        this.postInitiativesFilter.setItems(items);
    }

    public setPostIntentsFilterItems(items){
        for (let item of items){
            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no intents'});
        this.postIntentsFilter.setItems(items);
    }

    public setPostContentTypesFilterItems(items){

        items.unshift({id: 0, name: 'no post types', contentTypes: [{id: 0, name: 'no post types'}]});

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.postContentTypesFilter.setMultiSectionItems(groups);
        this.postContentTypesFilter.setLabel('Content Types');
    }

    public setNetworkCategoriesFilterItems(items){

        items.unshift({id: 0, name: 'no network categories', networkCategories: [{id: 0, name: 'no network categories'}]});

        let groups = [];
        for (let groupedNetworkCategory of items){

            let group = {"name" : groupedNetworkCategory.name, "items" : groupedNetworkCategory.networkCategories};
            groups.push(group);
        }

        this.networkCategoriesFilter.setMultiSectionItems(groups);
        this.networkCategoriesFilter.setLabel('Network Categories');
    }

    public setPrimaryCategoriesFilterItems(items){

        this.primaryCategoriesFilter.setItems(items);
    }

    public setSrEditorsFilterItems(items){

        for (let item of items){
            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        this.srEditorsFilter.setItems(items);
    }

    public setJrEditorsFilterItems(items){

        for (let item of items){
            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        this.jrEditorsFilter.setItems(items);
    }

    public setPublishStatusItems(){
        this.getTemplateViewModel().publishStatus(this.publishStatus);
    }

    public setRoiData(roiData){

        this.setDynamicHeaders();
        this.showExportButton();
        this.showExportReconciliationButton();
        roiData.roiDataPerDimensionGroupings.push(roiData.totalRoiData);
        this.getTemplateViewModel().roiData(roiData.roiDataPerDimensionGroupings);
    }

    public setInProgress(items){

        this.getTemplateViewModel().inProgress(items);
    }

    public onClickReorder(value, data, event){
        if(typeof data.orderBy === 'undefined'){
            data = this.getTemplateViewModel();
        }
        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection() === null || data.orderByAndDirection().includes(value)){
            if( data.orderByDirection() == "DESC" ){
                data.orderByDirection("ASC");
            }
            else{
                data.orderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.hideExportButton();
        this.caller.listReorder();
    }

    public validateOrderBy(){
        let orderByChoosen = this.getTemplateViewModel().orderBy();

        // @ts-ignore
        let orderByIsDimension = roi_tool_template.dimensionGroupingItems.find(i => i.backendName === orderByChoosen);

        if(orderByIsDimension != null){
            let orderByInSelectedDimension = this.getTemplateViewModel().groupingDimensionsSelected().find(i => i.backendName === orderByChoosen);

            if(typeof orderByInSelectedDimension === 'undefined'){

                this.getTemplateViewModel().orderBy(null);
                this.getTemplateViewModel().orderByAndDirection(null);
            }
        }
    }

    private setDynamicHeaders() {
        this.getTemplateViewModel().dynamicHeadersList([]);
        for (let selectedDimensionItem of this.getTemplateViewModel().dimensionGrouping.selectedItemsOrderBySelection()) {
            for (let dimensionItem of roi_tool_template.dimensionGroupingItems) {
                if (selectedDimensionItem === dimensionItem.id) {
                    this.getTemplateViewModel().dynamicHeadersList.push(dimensionItem);
                }
            }
        }
    }

    public resetDefaultDimensionFilters(){
        if(this.getTemplateViewModel().dimensionGrouping.selectedItems().length === 0){
            this.dimensionGrouping.getTemplateViewModel().selectedItems(["dateData"]);
            this.dimensionGrouping.setSelectedItemsOrderBySelection([{"id":"dateData"}]);
        }
    }

    public setSelectDimensionsObjects(){
        this.getTemplateViewModel().groupingDimensionsSelected([]);
        for (let selectedDimensionItem of this.getTemplateViewModel().dimensionGrouping.selectedItemsOrderBySelection()) {
            for (let dimensionItem of roi_tool_template.dimensionGroupingItems) {
                if (selectedDimensionItem === dimensionItem.id) {
                    this.getTemplateViewModel().groupingDimensionsSelected.push(dimensionItem);
                }
            }
        }
    }

    private exportData(obj){

        let fileName = "roi_data_" + this.datesFilter.getTemplateViewModel().startDate() + "_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportRoiDataCsv.exportToCsv(fileName, this.getTemplateViewModel().roiData());
    }

    private exportReconciliationData(obj){

        let check = this.getTemplateViewModel().roiReconciliationDataButtonClickable();
        if (check) {

            this.getTemplateViewModel().roiReconciliationDataButtonClickable(0);
            this.caller.getCsvReconciliationData();
        }
    }

    private setExportReconciliationData(data){

        this.getTemplateViewModel().roiReconciliationData(data);

        let fileName = "ROI_Cost_Reconciliation_from_" + this.datesFilter.getTemplateViewModel().startDate() + "_to_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportRoiReconciliationDataCsv.exportToCsv(fileName, this.getTemplateViewModel().roiReconciliationData());
        this.getTemplateViewModel().roiReconciliationDataButtonClickable(1);

    }

    public hideExportButton(){
        this.getTemplateViewModel().exportButtonHidden(1);
    }

    public showExportButton(){
        this.getTemplateViewModel().exportButtonHidden(0);
    }

    public hideExportReconciliationButton(){
        this.getTemplateViewModel().exportReconciliationButtonHidden(1);
    }

    public showExportReconciliationButton(){
        this.getTemplateViewModel().exportReconciliationButtonHidden(0);
    }

    private onPublishStatusChange(){
        this.caller.getListData();
    }

    /**
     * @inheritDoc
     */
    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.brandsFilter, params['brands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postInitiativesFilter, params['postInitiatives']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postIntentsFilter, params['postIntents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postContentTypesFilter, params['postContentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.networkCategoriesFilter, params['networkCategories']);

        let permissions = this.getTemplateViewModel().permissions();
        if (permissions['roi tool page cost breakdown'].read) {

            this.presetFilter.setMultiSelectorPresetFilters(this.costsFilter, params['costs']);
        }

        this.presetFilter.setMultipleAutocompletePresetFilter(this.primaryCategoriesFilter, params['idPrimaryCategories'], params['namePrimaryCategories']);

        this.presetFilter.setMultipleAutocompletePresetFilter(this.srEditorsFilter, params['srEditors'], params['srEditorName']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.jrEditorsFilter, params['jrEditors'], params['jrEditorName']);

        if(typeof params['dimensionGroupings'] !== 'undefined'){

            let dimensionGroupingIds = [];

            for (let dimensionGrouping of params['dimensionGroupings']){

                dimensionGroupingIds.push(dimensionGrouping.id);
            }

            this.presetFilter.setMultiSelectorPresetFilters(this.dimensionGrouping, dimensionGroupingIds);
            this.getTemplateViewModel().groupingDimensionsSelected(params['dimensionGroupings']);
        }

        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        // Publishing type custom filter
        if(typeof params['publishStatus'] !== 'undefined'){

            this.getTemplateViewModel().publishStatusSelected(params['publishStatus']);
        }
    }

    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }

    public setCostsFilterItems(){

        this.costsFilter.setItems(this.costs);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/roi_tool_template.ts